

export const auctions = [
    {
        name: 'Auction 1',
        price: '0.21 Weth',
        time: '1.23.34',
        image: 'https://images.unsplash.com/photo-1533644756484-bb7b29ac7fcd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
        createdBy: '92x2313xSe2',
        collection: 'Amoled Collection',
    },
    {
        name: 'Auction 2',
        price: '0.22 Weth',
        time: '1.53.12',
        image: 'https://images.unsplash.com/photo-1571064082088-ec145fc23f10?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection: 'Amoled Collection',
    },
    {
        name: 'Auction 3',
        price: '0.23 Weth',
        time: '1.2.23',
        image: 'https://images.unsplash.com/photo-1505480449763-8f5c78af9caa?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection: 'Amoled Collection',
    },
    {
        name: 'Auction 4',
        price: '0.19 Weth',
        time: '2.23.34',
        image: 'https://images.unsplash.com/photo-1579158952347-6cff5d2f5cda?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection: 'Amoled Collection',
    },
    {
        name: 'Auction 5',
        price: '0.25 Weth',
        time: '1.11.34',
        image: 'https://images.unsplash.com/photo-1570361269465-290e1149df5d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2101&q=80',
        collection: 'Amoled Collection',
    },
    {
        name: 'Auction 6',
        price: '0.30 Weth',
        time: '5.53.55',
        image: 'https://images.unsplash.com/photo-1651054558996-03455fe2702f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection: 'Amoled Collection',
    },
    {
        name: 'Auction 7',
        price: '0.21 Weth',
        time: '1.35.14',
        image: 'https://images.unsplash.com/photo-1523441263-830cac2fe90b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection: 'Amoled Collection',
    },
    {
        name: 'Auction 8',
        price: '0.25 Weth',
        time: '15.11.34',
        image: 'https://images.unsplash.com/photo-1583988989386-f0e2797e424b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection: 'Amoled Collection',
    },
]